import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ServicesService } from 'app/services/services/services.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-liste-services',
  templateUrl: './liste-services.component.html',
  styleUrls: ['./liste-services.component.scss']
})
export class ListeServicesComponent implements OnInit {

  public services:any
  dataSource = new MatTableDataSource();

  constructor(private serviceService:ServicesService) { }
getData(){
  this.serviceService.getListService().subscribe(data =>{
    this.services=data
  })
}
  ngOnInit(): void {
    this.serviceService.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }

  deleteAgenciesService1(agencieService: any) {
    this.serviceService.deleteService(agencieService.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
    setTimeout(() => {
      this.getData()
    }, 500)

  }







  deleteAgenciesService(agencieService: any) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.serviceService.deleteService(agencieService.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          // this.AgenciesTunis.splice(i,1)
  
          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text:  "Votre agence a été supprimée.",
            icon:  "success"
          });
          // Fetch the updated data after deletion
         
        }); setTimeout(() => {
          this.getData()
          }, 500);
        
      }
    });
  }


  
}
